export default {"src":"/_next/static/media/bank-linepay.95251aba.svg","height":24,"width":83,"blurWidth":0,"blurHeight":0};